import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = ProjectVenue;

export const getProjectVenue = createAppAsyncThunk(
  'projectVenue/getProjectVenue',
  async (
    id: number,
    { extra: { projectVenueGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const project = await projectVenueGateway.get(id);
      return project;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetProject.Message.error'));
}
